var _a, _b;
import { BrowserClient, defaultIntegrations, defaultStackParser, Hub, makeFetchTransport, } from '@sentry/browser';
import { Env, isProd } from './environment';
const client = new BrowserClient({
    enabled: isProd,
    dsn: 'https://8412e41489004ae386a1b7d3afcbfb83@o22381.ingest.sentry.io/4504843341660160',
    release: '9f3e96857cd685fad00baa2583ccf27635fb3d24',
    transport: makeFetchTransport,
    stackParser: defaultStackParser,
    integrations: defaultIntegrations.filter(integration => integration.name !== 'GlobalHandlers'),
    environment: Env,
});
export const hub = new Hub(client);
hub.setTags({
    url: (_b = (_a = globalThis.window) === null || _a === void 0 ? void 0 : _a.location.href) !== null && _b !== void 0 ? _b : 'SERVER_SIDE_RENDERING',
});
export const captureException = (exc, hint) => hub.captureException(exc, hint);
